import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { formatDateTime } from '../../../../util/datetime'
import { renderStateName } from '../../util/names'
import currentUserHasAccess from '../../../../util/widget-helper'
import { STATE_TRANSITION_LOG_CONTAINER } from '../../ui-definition/process-ui'


const StateTransitionLog = ({ processStateHistoryList }) => {
    if (!currentUserHasAccess(STATE_TRANSITION_LOG_CONTAINER)) {
        return null
    }

    return (
        <ContentBox title="State History">
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>Time</th>
                                <th>new status</th>
                                <th>Changed by</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                processStateHistoryList.map(history => {
                                    return (<tr
                                        key={history.id}
                                    >
                                        <td>{formatDateTime(history.changed)}</td>
                                        <td>{renderStateName(history.targetStateName)}</td>
                                        <td>{history.changedByUserName}</td>
                                    </tr>)
                                })
                            }
                        </tbody>
                    </table>
                </Column>

            </Row>
        </ContentBox>
    )
}

StateTransitionLog.propTypes = {
    processStateHistoryList: PropTypes.array,
}


export default StateTransitionLog



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/StateTransitionLog.js